<template>
  <div class='time-chang x-d-flex'>
    <div class="x-m-r-10">
      <el-date-picker v-model="dataTime" type="datetimerange" :clearable="false" @change="setTime(dataTime)"
        value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:01', '23:59:59']" range-separator="至"
        start-placeholder="开始日期" end-placeholder="结束日期">
      </el-date-picker>
    </div>
    <div class="x-d-flex">
      <el-button-group class="x-h36">
        <el-button plain v-for="(item,index) in indexTimeData" :key="index" class="x-h36 x-p-0 x-w60"
          :type="indexTimeId == item.id?'primary':''" @click="clickTime(item.id)">{{item.name}}</el-button>
      </el-button-group>
    </div>
  </div>
</template>

<script>
  export default {
    components: {},
    props: {
      from: {
        type: String,
        default: ''
      },
    },
    data() {
      return {
        // 时间
        dataTime: [],
        indexTimeId: 2,
        indexTimeData2: [{
          id: 2,
          name: "昨天",
        }, {
          id: 3,
          name: "本月",
        }, {
          id: 1,
          name: "上月"
        }, {
          id: 4,
          name: "近7天",
        }, {
          id: 5,
          name: "近30天",
        }],
        indexTimeData1: [{
          id: 6,
          name: "今天",
        }, {
          id: 3,
          name: "本月",
        }, {
          id: 1,
          name: "上月"
        }, {
          id: 4,
          name: "近7天",
        }, {
          id: 5,
          name: "近30天",
        }],
      };
    },
    computed: {},
    watch: {},
    methods: {
      // 点击按钮切换时间选中状态
      clickTime(id) {
        this.indexTimeId = id;
        this.dataTime = []; //清空当前的时间
        if (id == 1) {
          this.dataTime = [this.api.timeHelper.getLastMonthStartDate() + ' 00:00:01', this.api.timeHelper
            .getLastMonthEndDate() + ' 23:59:59'
          ];
        } else if (id == 2) {
          this.dataTime = [this.api.timeHelper.fGetQhDay(-1) + ' 00:00:01', this.api.timeHelper.fGetQhDay(-1) +
            ' 23:59:59'
          ];
        } else if (id == 3) {
          this.dataTime = [this.api.timeHelper.getMonthStartDate() + ' 00:00:01', this.api.timeHelper
            .getMonthEndDate() + ' 23:59:59'
          ];
        } else if (id == 4) {
          this.dataTime = [this.api.timeHelper.fGetQhDay(-6) + ' 00:00:01', this.api.timeHelper.fGetNowTime(1) +
            ' 23:59:59'
          ];
        } else if (id == 5) {
          this.dataTime = [this.api.timeHelper.fGetQhDay(-30) + ' 00:00:01', this.api.timeHelper.fGetNowTime(1) +
            ' 23:59:59'
          ];
        } else if (id == 6) { //今日

          this.dataTime = [this.api.timeHelper.fGetQhDay(0) + ' 00:00:01', this.api.timeHelper.fGetQhDay(0) +
            ' 23:59:59'
          ];

        }

        if (Number(this.api.timeHelper.fDateFat('yyyyMMddhhmmss', this.dataTime[0])) <= 20221230000000) {
          console.log(Number(this.api.timeHelper.fDateFat('yyyyMMddhhmmss', this.dataTime[0])))
          // this.dataTime[0] = ['2022-12-30 00:00:01']
          // return this.$message('开始时间不能早于2022-12-30')
        }
        if (Number(this.api.timeHelper.fDateFat('yyyyMMddhhmmss', this.dataTime[0]).substring(0, 4)) != Number(this.api
            .timeHelper.fDateFat('yyyyMMddhhmmss', this.dataTime[1]).substring(0, 4))) {
          // this.dataTime[0] = ['2023-01-01 00:00:01']
          // return this.$message('不能跨年查询')
        }

        // 点击按钮切换数据 【传递给父组件】
        this.$emit('getTimeData', this.dataTime);
      },
      // 切换获取时间  【传递给父组件】
      setTime(time) {
        console.log(time)
        let starTime = this.api.timeHelper.fDateFat('yyyyMMddhhmmss', time[0])
        let overTime = this.api.timeHelper.fDateFat('yyyyMMddhhmmss', time[1])
        if (Number(starTime) <= 20221230000001) {
          return this.$message('开始时间不能早于2022-12-30')
        }
        if (Number(starTime.substring(0, 4)) != Number(overTime.substring(0, 4))) {
          return this.$message('不能跨年查询')
        }
        this.$emit('getTimeData', time);
        // 根据切换获取的时间，判断选中的按钮
        let jin = [this.api.timeHelper.fGetQhDay(0) + ' 00:00:01', this.api.timeHelper.fGetNowTime(1) + ' 23:59:59'];
        let lastMouth = [this.api.timeHelper.getLastMonthStartDate() + ' 00:00:01', this.api.timeHelper
          .getLastMonthEndDate() + ' 23:59:59'
        ]
        let zuo = [this.api.timeHelper.fGetQhDay(-1) + ' 00:00:01', this.api.timeHelper.fGetQhDay(-1) + ' 23:59:59'];
        let ben = [this.api.timeHelper.getMonthStartDate() + ' 00:00:01', this.api.timeHelper.getMonthEndDate() +
          ' 23:59:59'
        ];
        let zui = [this.api.timeHelper.fGetQhDay(-6) + ' 00:00:01', this.api.timeHelper.fGetNowTime(1) + ' 23:59:59'];
        let zui3 = [this.api.timeHelper.fGetQhDay(-30) + ' 00:00:01', this.api.timeHelper.fGetNowTime(1) + ' 23:59:59'];
        if (time[0] == lastMouth[0] && time[1] == lastMouth[1]) {
          this.indexTimeId = 1;
        } else if (time[0] == zuo[0] && time[1] == zuo[1]) {
          this.indexTimeId = 2;
        } else if (time[0] == ben[0] && time[1] == ben[1]) {
          this.indexTimeId = 3;
        } else if (time[0] == zui[0] && time[1] == zui[1]) {
          this.indexTimeId = 4;
        } else if (time[0] == zui3[0] && time[1] == zui3[1]) {
          this.indexTimeId = 5;
        } else {
          this.indexTimeId = 22;
        }
      },
    },
    beforeCreate() {},
    async created() {
      // 默认获取当天时间
      // this.dataTime=[this.api.timeHelper.fGetQhDay(0)+' 00:00:01',this.api.timeHelper.fGetNowTime(1)+' 23:59:59'];
      //deviceRecord 设备记录默认当天
      if (this.from == 'deviceRecord') {
        this.clickTime(6)
        this.indexTimeData = this.indexTimeData1
      } else {
        this.clickTime(2)
        this.indexTimeData = this.indexTimeData2
      }
    },
    beforeMount() {},
    mounted() {

    }
  }
</script>
<style lang="less" scoped>
  .time-chang {
    .el-button {
      padding: 0px;
    }

    .el-button.is-plain:focus,
    .el-button.is-plain:hover {
      color: #ff5757;
      background: #fff;
      border-color: #ff5757;
    }

    // 选中状态
    .el-button--primary.is-plain {
      color: #ff5757;
      background: #fff;
      border-color: #ff5757;
      z-index: 1;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/timeChang.vue